/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateIndicatorTestDto
 */
export interface CreateUpdateIndicatorTestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateIndicatorTestDto
     */
    testId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateIndicatorTestDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateIndicatorTestDto
     */
    mode?: CreateUpdateIndicatorTestDtoModeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateIndicatorTestDto
     */
    keyTestId?: string | null;
}


/**
 * @export
 */
export const CreateUpdateIndicatorTestDtoModeEnum = {
    NumberOfCorrectAnswers: 'NumberOfCorrectAnswers',
    SumOfPresentationTime: 'SumOfPresentationTime',
    WeightedSum: 'WeightedSum',
    WeightedValueSum: 'WeightedValueSum'
} as const;
export type CreateUpdateIndicatorTestDtoModeEnum = typeof CreateUpdateIndicatorTestDtoModeEnum[keyof typeof CreateUpdateIndicatorTestDtoModeEnum];


/**
 * Check if a given object implements the CreateUpdateIndicatorTestDto interface.
 */
export function instanceOfCreateUpdateIndicatorTestDto(value: object): value is CreateUpdateIndicatorTestDto {
    return true;
}

export function CreateUpdateIndicatorTestDtoFromJSON(json: any): CreateUpdateIndicatorTestDto {
    return CreateUpdateIndicatorTestDtoFromJSONTyped(json, false);
}

export function CreateUpdateIndicatorTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateIndicatorTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'testId': json['testId'] == null ? undefined : json['testId'],
        'name': json['name'] == null ? undefined : json['name'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'keyTestId': json['keyTestId'] == null ? undefined : json['keyTestId'],
    };
}

export function CreateUpdateIndicatorTestDtoToJSON(value?: CreateUpdateIndicatorTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'testId': value['testId'],
        'name': value['name'],
        'mode': value['mode'],
        'keyTestId': value['keyTestId'],
    };
}

